import React, { useState } from "react";
import ImageWithZoom from "../../atoms/ImageWithZoom";
import { StyledBrandGalleryHolder, StyledSlider, GalleryImageContainer } from "./style";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export interface ImageGalleryCarouselProps {
  galleryPhotos: string[];
  sliderWidth: string;
  shouldZoom?: boolean;
  shouldAutoplay?: boolean;
  autoplaySpeedInterval?: number;
  autoplayAnimationSpeed?: number;
  objectFit?: string;
  variant: "small" | "large" | "fullPage" | "addRewardTray";
  bgColor: string;
  isLocked: boolean;
}

const ImageGalleryCarousel = ({
  galleryPhotos,
  sliderWidth,
  shouldZoom = true,
  shouldAutoplay = true,
  autoplaySpeedInterval = 3000,
  autoplayAnimationSpeed = 1000,
  variant,
  bgColor,
  objectFit = "cover",
  isLocked,
}: ImageGalleryCarouselProps) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState<number>(0);
  const hasManyPhotos = galleryPhotos.length > 1;

  const settings = {
    autoplay: shouldAutoplay,
    autoplaySpeed: autoplaySpeedInterval,
    speed: autoplayAnimationSpeed,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleCurrentSlideChange = (nextSlide: number) => {
    if (nextSlide !== currentSlideIndex) {
      setCurrentSlideIndex(nextSlide);
    }
  };

  const getVariantVariables = () => {
    switch (variant) {
      case "fullPage":
        return {
          galleryImageContainerHeight: "auto",
          galleryImageContainerPadding: "0 0 10px 0",
          imageWithZoomHeight: "auto",
          xsDownHeight: "360px",
        };
      case "addRewardTray":
        return {
          galleryImageContainerHeight: "300px",
          galleryImageContainerPadding: "20px 0",
          imageWithZoomHeight: "260px",
          xsDownHeight: "260px",
        };
      default:
        return {
          galleryImageContainerHeight: "510px",
          galleryImageContainerPadding: "0 0 40px 0",
          imageWithZoomHeight: "470px",
          xsDownHeight: "360px",
        };
    }
  };

  const { galleryImageContainerHeight, galleryImageContainerPadding, imageWithZoomHeight, xsDownHeight } =
    getVariantVariables();

  return (
    <StyledBrandGalleryHolder>
      <StyledSlider
        {...settings}
        sliderWidth={sliderWidth}
        beforeChange={(currentSlide: number, nextSlide: number) => handleCurrentSlideChange(nextSlide)}
        variant={variant}
      >
        {galleryPhotos?.map((photo: string, index: number) => (
          <div key={photo}>
            <GalleryImageContainer
              key={photo}
              height={galleryImageContainerHeight}
              paddingBottom={galleryImageContainerPadding}
              bgColor={bgColor}
              isLocked={isLocked}
            >
              <ImageWithZoom
                width="100%"
                height={imageWithZoomHeight}
                xsDownHeight={xsDownHeight}
                objectFit={objectFit}
                zoomScale={1.5}
                photoSrc={photo}
                disableZoom={!shouldZoom || !(index === currentSlideIndex)}
                isPartOfGallery={hasManyPhotos}
              />
            </GalleryImageContainer>
          </div>
        ))}
      </StyledSlider>
    </StyledBrandGalleryHolder>
  );
};

export default ImageGalleryCarousel;
